export interface StatusProps {
  val: string;
  options?: any;
  row?: any;
}
export default function Status(props: StatusProps) {
  const bgColor = props.options?.inputProps.bgColor(props.row);
  const textColor = props.options?.inputProps.textColor(props.row);
  return (
    <div
      className="rounded-full flex justify-center items-center text-xs"
      style={{ backgroundColor: bgColor || "", color: textColor || "" }}
    >
      {props.val}
    </div>
  );
}
